/* eslint-disable @typescript-eslint/no-empty-interface */

import { ERouteHttpVerb } from "@devowl-wp/api";
var EPaddleProductPlanGetMode = /*#__PURE__*/function (EPaddleProductPlanGetMode) {
  EPaddleProductPlanGetMode["Standard"] = "standard";
  EPaddleProductPlanGetMode["PayLink"] = "pay-link";
  return EPaddleProductPlanGetMode;
}(EPaddleProductPlanGetMode || {});
const routeLocationPaddleProductPlanGet = {
  path: "/paddle/product/plan",
  method: ERouteHttpVerb.GET
};
export { routeLocationPaddleProductPlanGet, EPaddleProductPlanGetMode };